import * as React from "react";
import { injectIntl, InjectedIntlProps, FormattedMessage } from "react-intl";
import { RouteComponentProps } from "react-router";
import * as moment from "moment";
import {Table, Input, message, Button } from "antd";
import { consoleApi } from "src/apiMiddleware";
import empty from "../../../assets/image/empty.svg";
import { RoomInfType } from "src/models/RoomStore";
import copy from "copy-to-clipboard";
import { Link } from "@netless/i18n-react-router";
import {CopyOutlined, LoadingOutlined} from "@ant-design/icons/lib";
const { Search } = Input;

export enum DebugTypeEnum {
    room = "room",
    replay = "replay",
    index = "index",
}

export type LogSearchProps = RouteComponentProps<{}> & InjectedIntlProps;
export type LogType = {
    key: string,
    ip: string,
    time: string,
    akkoVersion: string,
    level: string,
    message: string,
    os: string,
    platform: string,
    sdkVersion: string,
    userId: string,
    uuid: string,
};

export type LogSearchStates = {
    logArray: LogType[];
    uuid: string;
    isMaskLoading: boolean;
    rooms: any[];
    searchText: any;
    activeUuid: string;
};

class LogSearch extends React.Component<LogSearchProps, LogSearchStates> {
    public constructor(props: LogSearchProps) {
        super(props);
        this.state = {
            logArray: [],
            uuid: "",
            isMaskLoading: false,
            rooms: [],
            searchText: "",
            activeUuid: "",
        };
    }
    public async componentDidMount(): Promise<void> {
        await this.loadRoom(1, 50);
    }
    public loadRoom = async (offset: number, limit: number): Promise<void> => {
        try {
            this.setState({ isMaskLoading: true });
            const resp = await consoleApi.data.getRoomData(offset, limit);
            if (resp.code === 200) {
                const rooms: any[] = resp.data.rooms.map((data: any, index: number) => {
                    return {
                        key: `room-${index}`,
                        ...data,
                    };
                });
                this.setState({ rooms: rooms, isMaskLoading: false });
            }
        } catch (err) {
            message.error(err.message);
            this.setState({ isMaskLoading: false });
        }
    }

    private renderMask = (): React.ReactNode => {
        if (this.state.isMaskLoading) {
            return (
                <div className="content-box-mask">
                    <LoadingOutlined style={{ fontSize: 36, color: "#3381FF" }}/>
                </div>
            );
        } else {
            return null;
        }
    }


    private handleSearchAll = async (uuid: string): Promise<void> => {
        const res = await consoleApi.data.getRoomDataByUuid(uuid);
        const room: RoomInfType = { ...res.data.room, key: `search` };
        this.setState({ rooms: [room], isMaskLoading: false });
    }

    private renderRoomListTable = (roomDataSource: any[]): React.ReactNode => {
        if (roomDataSource && roomDataSource.length > 0) {
            const columns = [
                {
                    title: this.props.intl.formatMessage({ id: "room-uuid" }),
                    dataIndex: "uuid",
                    key: "uuid",
                    render: (text: any, record: any, index: any): React.ReactNode => {
                        return (
                            <>
                                <CopyOutlined onClick={() => {
                                    copy(text.toString());
                                    message.success("Copy to clipboard");
                                }} />
                                <span>{text.toString()}</span>
                            </>
                        );
                    },
                },
                {
                    title: this.props.intl.formatMessage({ id: "creation-time" }),
                    dataIndex: "createdAt",
                    key: "createdAt",
                    render: (text: any, record: any, index: any): React.ReactNode => {
                        return <div key={`tag-${index}`} >
                            {moment(text).format("L")}
                        </div>;
                    },
                },
                {
                    title: this.props.intl.formatMessage({ id: "log-details" }),
                    dataIndex: "log",
                    key: "log",
                    render: (text: any, record: any, index: any) => {
                        const startTime = moment(record.createdAt).valueOf();
                        return (
                            <Link to={`/log/${record.uuid}/${startTime}/`}>
                                <Button key={`btn-${index}`}>
                                    {this.props.intl.formatMessage({ id: "view-log" })}
                                </Button>
                            </Link>
                        );
                    },
                },
            ];
            return (
                <Table style={{ width: "100%" }} columns={columns} dataSource={roomDataSource} />
            );
        } else {
            return (
                <div style={{ minHeight: 480 }} className={"table-empty-box"}>
                    <img src={empty} />
                </div>
            );
        }
    }
    public render(): React.ReactNode {
        return (
            <div className="product-center-box">
                <div className="portal-room-outbox">
                    <div className="portal-room-chart">
                        <div className="portal-room-box-mid">
                            {this.renderMask()}
                            <div className="console-content-title-max">
                                <span className="console-content-title-text">
                                    <FormattedMessage
                                        id="menu-slider.log-search"
                                    />
                                </span>
                                <Search style={{ width: 280, marginRight: 20 }} placeholder={this.props.intl.formatMessage({ id: "enter-uuid" })}
                                    onSearch={this.handleSearchAll} enterButton />
                            </div>
                            <div className="console-content-chart-body">
                                {this.renderRoomListTable(this.state.rooms)}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}


export default injectIntl(LogSearch);



// WEBPACK FOOTER //
// ./src/components/portal/logSearch/LogSearch.tsx